module.exports = __webpack_public_path__ + "img/08.4847ee93.jpg";